import dayjs from 'dayjs';

/**
 * Regression 27 Sep - one way to write money and moments in the panel.
 *
 * Amounts were written with a bare toLocaleString(): "£10,290.2" (the trailing
 * zero lost) and the browser's own locale; timestamps with new
 * Date().toLocaleString(): "9/25/2026, 8:36:46 AM" next to "30/09/2026 09:00"
 * everywhere else (SHAR-1068). Now: always two decimals, en-GB grouping, and
 * DD/MM/YYYY HH:mm.
 */
const two = (v: number) => v.toLocaleString('en-GB', { minimumFractionDigits: 2, maximumFractionDigits: 2 });

/** "£10,290.20"; "—" when there is no number. */
export function gbp(v: number | string | null | undefined): string {
  const n = Number(v);
  return v === null || v === undefined || v === '' || !Number.isFinite(n) ? '—' : `£${two(n)}`;
}

/** An amount in another currency, without the symbol: "8,000.00". */
export function amount(v: number | string | null | undefined): string {
  const n = Number(v);
  return v === null || v === undefined || v === '' || !Number.isFinite(n) ? '—' : two(n);
}

/** "25/09/2026 12:11" (local time, as the other dates in the panel). */
export function dateTime(v: string | Date | null | undefined): string {
  return v ? dayjs(v).format('DD/MM/YYYY HH:mm') : '—';
}

/**
 * SHAR-1183 — the one name of the commission. The same charge was called
 * "Processing commission", "Processing fee", "Admin fee" and "Admin fee
 * (Stripe)" on different pages; every page now uses this.
 */
export const COMMISSION_LABEL = 'Processing commission';

/** "Processing commission (2.5%)", or the bare name when the percentage is unknown. */
export function commissionLabel(pct?: number | string | null): string {
  const n = Number(pct);
  return pct === null || pct === undefined || pct === '' || !Number.isFinite(n)
    ? COMMISSION_LABEL
    : `${COMMISSION_LABEL} (${n}%)`;
}
